export const HOME_SAVE_TOKEN_FROM_ORGANIZATION = 'HOME_SAVE_TOKEN_FROM_ORGANIZATION';
export const HOME_LOAD_COLLECTIONS_BEGIN = 'HOME_LOAD_COLLECTIONS_BEGIN';
export const HOME_LOAD_COLLECTIONS_SUCCESS = 'HOME_LOAD_COLLECTIONS_SUCCESS';
export const HOME_LOAD_COLLECTIONS_FAILURE = 'HOME_LOAD_COLLECTIONS_FAILURE';
export const HOME_LOAD_COLLECTIONS_DISMISS_ERROR = 'HOME_LOAD_COLLECTIONS_DISMISS_ERROR';
export const HOME_LOAD_PAGES_BEGIN = 'HOME_LOAD_PAGES_BEGIN';
export const HOME_LOAD_PAGES_SUCCESS = 'HOME_LOAD_PAGES_SUCCESS';
export const HOME_LOAD_PAGES_FAILURE = 'HOME_LOAD_PAGES_FAILURE';
export const HOME_LOAD_PAGES_DISMISS_ERROR = 'HOME_LOAD_PAGES_DISMISS_ERROR';
export const HOME_LOAD_PROJECT_ASSETS_BEGIN = 'HOME_LOAD_PROJECT_ASSETS_BEGIN';
export const HOME_LOAD_PROJECT_ASSETS_SUCCESS = 'HOME_LOAD_PROJECT_ASSETS_SUCCESS';
export const HOME_LOAD_PROJECT_ASSETS_FAILURE = 'HOME_LOAD_PROJECT_ASSETS_FAILURE';
export const HOME_LOAD_PROJECT_ASSETS_DISMISS_ERROR = 'HOME_LOAD_PROJECT_ASSETS_DISMISS_ERROR';
export const HOME_LOAD_PROJECT_BEGIN = 'HOME_LOAD_PROJECT_BEGIN';
export const HOME_LOAD_PROJECT_SUCCESS = 'HOME_LOAD_PROJECT_SUCCESS';
export const HOME_LOAD_PROJECT_FAILURE = 'HOME_LOAD_PROJECT_FAILURE';
export const HOME_LOAD_PROJECT_DISMISS_ERROR = 'HOME_LOAD_PROJECT_DISMISS_ERROR';
export const HOME_LOAD_SNIPPETS_BEGIN = 'HOME_LOAD_SNIPPETS_BEGIN';
export const HOME_LOAD_SNIPPETS_SUCCESS = 'HOME_LOAD_SNIPPETS_SUCCESS';
export const HOME_LOAD_SNIPPETS_FAILURE = 'HOME_LOAD_SNIPPETS_FAILURE';
export const HOME_LOAD_SNIPPETS_DISMISS_ERROR = 'HOME_LOAD_SNIPPETS_DISMISS_ERROR';
export const HOME_LOAD_EVENTS_BEGIN = 'HOME_LOAD_EVENTS_BEGIN';
export const HOME_LOAD_EVENTS_SUCCESS = 'HOME_LOAD_EVENTS_SUCCESS';
export const HOME_LOAD_EVENTS_FAILURE = 'HOME_LOAD_EVENTS_FAILURE';
export const HOME_LOAD_EVENTS_DISMISS_ERROR = 'HOME_LOAD_EVENTS_DISMISS_ERROR';
export const HOME_LOAD_INSTALLED_PLUGIN_BEGIN = 'HOME_LOAD_INSTALLED_PLUGIN_BEGIN';
export const HOME_LOAD_INSTALLED_PLUGIN_SUCCESS = 'HOME_LOAD_INSTALLED_PLUGIN_SUCCESS';
export const HOME_LOAD_INSTALLED_PLUGIN_FAILURE = 'HOME_LOAD_INSTALLED_PLUGIN_FAILURE';
export const HOME_LOAD_INSTALLED_PLUGIN_DISMISS_ERROR = 'HOME_LOAD_INSTALLED_PLUGIN_DISMISS_ERROR';
export const HOME_UPDATE_LATEST_PUBLISH_VERSION_BEGIN = 'HOME_UPDATE_LATEST_PUBLISH_VERSION_BEGIN';
export const HOME_UPDATE_LATEST_PUBLISH_VERSION_SUCCESS =
  'HOME_UPDATE_LATEST_PUBLISH_VERSION_SUCCESS';
export const HOME_UPDATE_LATEST_PUBLISH_VERSION_FAILURE =
  'HOME_UPDATE_LATEST_PUBLISH_VERSION_FAILURE';
export const HOME_UPDATE_LATEST_PUBLISH_VERSION_DISMISS_ERROR =
  'HOME_UPDATE_LATEST_PUBLISH_VERSION_DISMISS_ERROR';
export const HOME_ADD_LAST_ACCESS_BEGIN = 'HOME_ADD_LAST_ACCESS_BEGIN';
export const HOME_ADD_LAST_ACCESS_SUCCESS = 'HOME_ADD_LAST_ACCESS_SUCCESS';
export const HOME_ADD_LAST_ACCESS_FAILURE = 'HOME_ADD_LAST_ACCESS_FAILURE';
export const HOME_ADD_LAST_ACCESS_DISMISS_ERROR = 'HOME_ADD_LAST_ACCESS_DISMISS_ERROR';

export const HOME_VIBE_CODE_PUBLISH_BEGIN = 'HOME_VIBE_CODE_PUBLISH_BEGIN';
export const HOME_VIBE_CODE_PUBLISH_SUCCESS = 'HOME_VIBE_CODE_PUBLISH_SUCCESS';
export const HOME_VIBE_CODE_PUBLISH_ERROR = 'HOME_VIBE_CODE_PUBLISH_ERROR';
export const HOME_VIBE_CODE_PUBLISH_DISMISS_ERROR = 'HOME_VIBE_CODE_PUBLISH_DISMISS_ERROR';
